<template>
  <div class="default-snackbar"
      :class="{
        'default-snackbar--success': type === 'success',
        'default-snackbar--error': type === 'error'
      }"
  >
    <div class="default-snackbar__message">{{ message }}</div>
    <img
        src="@/assets/images/svg/close-white.svg"
        alt="exchange icon"
        class="default-snackbar__close"
        @click="hideSnackbar"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "DefaultSnackbar",
  props: {
    message: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'success',
    }
  },
  methods: {
    ...mapActions({
      hideSnackbar: 'hideSnackbar'
    })
  }
}
</script>

<style lang="scss" scoped>
  .default-snackbar {
    padding: 1rem 1.25rem;
    display: flex;
    justify-content: space-between;

    &--success {
      background: #1c840d;
    }

    &--error {
      background: #ea2c18;
    }

    &__message {
      color: #ffffff;
      font-weight: 600;
      width: calc(100% - 12px);
      text-align: center;
    }

    &__close {
      cursor: pointer;
    }

  }
</style>
